export default __webpack_public_path__ + "static/media/4.cae17388.jpg";